define('viewmodels/VisualAnalytics/VisualanalyticsRiskScores',['knockout', 'plugins/router', 'services/navigation', 'services/logger', 'durandal/app', 'durandal/system', 'services/appsecurity', 'viewmodels/GeneralSettings', 'services/utils', 'viewmodels/configuration/RisksAreasfactors', 'viewmodels/configuration/QualitativeSetup'], function (ko, router, navigation, logger, app, system, appsecurity, ObjGeneralSettings, utils, QuantitativeSetup, QualitativeSetup) {
    var title = 'Inherent Setup';
    var InherentVM = {
        activate: activate,
        attached: attached,
        detached: detached,
        title: title,
        utils: utils,
        appsecurity: appsecurity,
        QuantitativeSetup: QuantitativeSetup,
        QualitativeSetup: QualitativeSetup,
        SurveyCategoryList: ko.observableArray([]),
        ControlsAccessIS: ko.observable(false),
        SurveyGroupType: ko.observable(),
        SurveyCategoryTabClick: SurveyCategoryTabClick,
        OpenConfigureResponseTypePopup: OpenConfigureResponseTypePopup,
        GetSurveyCategoryTabsRs: GetSurveyCategoryTabsRs,
        AssessmentTypeId: ko.observable(),
        SelectedScenarioId: ko.observable(),

        ObjGeneralSettings: ObjGeneralSettings,
        LocaleCheckFlag: ko.observable(false),


    };
    return InherentVM;

    function activate() {
        try {

            if (InherentVM.ObjGeneralSettings === undefined || InherentVM.ObjGeneralSettings.LocalizedTextList() === undefined || ((InherentVM.ObjGeneralSettings.LocalizedTextList() !== undefined || InherentVM.ObjGeneralSettings.LocalizedTextList() !== null) && InherentVM.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                InherentVM.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (InherentVM.ObjGeneralSettings.LocalizedTextList() == undefined || InherentVM.ObjGeneralSettings.LocalizedTextList() == null || InherentVM.ObjGeneralSettings.LocalizedTextList().length <= 0 || InherentVM.ObjGeneralSettings.LocalizedIndexList() == undefined || InherentVM.ObjGeneralSettings.LocalizedIndexList() == null)
                        InherentVM.LocaleCheckFlag(false);
                    else
                        InherentVM.LocaleCheckFlag(true);
                });
            } else
                InherentVM.LocaleCheckFlag(true);

            //code
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in InherentSetup.js';
            logger.logMessage(msg);
        }
    }

    function detached() {
        try {
            //code
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in InherentSetup.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {

            if (InherentVM.ObjGeneralSettings === undefined || InherentVM.ObjGeneralSettings.LocalizedTextList() === undefined || ((InherentVM.ObjGeneralSettings.LocalizedTextList() !== undefined || InherentVM.ObjGeneralSettings.LocalizedTextList() !== null) && InherentVM.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                InherentVM.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (InherentVM.ObjGeneralSettings.LocalizedTextList() == undefined || InherentVM.ObjGeneralSettings.LocalizedTextList() == null || InherentVM.ObjGeneralSettings.LocalizedTextList().length <= 0 || InherentVM.ObjGeneralSettings.LocalizedIndexList() == undefined || InherentVM.ObjGeneralSettings.LocalizedIndexList() == null)
                        InherentVM.LocaleCheckFlag(false);
                    else
                        InherentVM.LocaleCheckFlag(true);
                });
            }


            GetSurveyCategoryTabsRs(AssessmentId, StateSelected, ScenarioId);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in InherentSetup.js';
            logger.logMessage(msg);
        }
    }

    function GetSurveyCategoryTabsRs(AssessmentId, StateSelected, ScenarioId) {
        try {

            InherentVM.AssessmentTypeId(AssessmentId);

            InherentVM.SelectedScenarioId(ScenarioId);

            $.ajax({
                url: "/api/Visualization/GetSurveyCategoryTabsByZATRAT",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { "AssessmentId": AssessmentId, "StateSelected": StateSelected, "IsOverall": false }
           })
                .success(function (jsonResult, success) {
                    if (jsonResult !== null) {
                        if (jsonResult.length > 0) {
                            var mappedTabList = $.map(jsonResult, function (result) {
                                return new SurveyCategoryModel(result);
                            });
                            $('#loadingMainImgDiv').show();
                            InherentVM.SurveyCategoryList(mappedTabList);
                            $('#InherentTabDiv').tabs();
                            $('#InherentTabDiv').tabs('refresh');
                            $('#InherentTabDiv').tabs({ active: 0 });
                            $("#InherentTabDiv").removeClass('ui-widget-content');
                            $("#tabContent").removeClass('ui-widget-content');
                            $($('#SurveyCategoryTabsDivRiskScores li').get(0)).trigger('click');
                            //$("ul#SurveyCategoryTabsDiv li").click();
                            scrollableTabs();
                            $('#PageButtonsDiv').show();
                        }
                        if (jsonResult.length === 0) {
                            $('#loadingMainImgDiv').hide();
                            $('#errorComp').show();
                            $('#PageButtonsDiv').hide();
                        }
                    }
                    else {
                        $('#loadingMainImgDiv').hide();
                        $('#errorComp').show();
                        $('#PageButtonsDiv').hide();
                    }
                })
                .fail(function (error, status) {
                    if (error.status === 401) {
                        app.showMessage(
                            //"You have been logged out. Please login again to complete the operation."
                            ((!InherentVM.LocaleCheckFlag() || InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : InherentVM.ObjGeneralSettings.LocalizedTextList()[InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name)
                            , "Error in Edit Operation"
                            , [((!InherentVM.LocaleCheckFlag() || InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : InherentVM.ObjGeneralSettings.LocalizedTextList()[InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString()]
                            , false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!InherentVM.LocaleCheckFlag() || InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : InherentVM.ObjGeneralSettings.LocalizedTextList()[InherentVM.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabsRs() method in InherentSetup.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabsRs() method in InherentSetup.js';
            logger.logMessage(msg);
        }
    }

    function SurveyCategoryTabClick(data, event) {
        try {

            var ScenarioId = InherentVM.SelectedScenarioId();

            $('#loadingMainImgDiv').show();
            $("#SurveyCategoryTabsDivRiskScores li").removeClass("active");

            //$('#SurveyCategoryTabsDiv li').removeClass('active');
            if (data.SurveyGroupShortName() === 'QTDR') {
                InherentVM.SurveyGroupType('QTDR');
                //$('#' + data.SurveyCategoryId()).addClass('active');
                $('#ParentTab_Scores_' + data.SurveyCategoryId()).addClass('active');
                ko.applyBindingsToNode($('#InnerInherentDiv').children().get(0), { compose: { model: 'viewmodels/VisualAnalytics/RiskAreasfactors', activationData: { InherentSetupQuantObj: { data, ScenarioId } } } }, InherentVM);

            }

            if (data.SurveyGroupShortName() === 'QLDR') {
                InherentVM.SurveyGroupType('QLDR');
                $('#ParentTab_Scores_' + data.SurveyCategoryId()).addClass('active');
                ko.applyBindingsToNode($('#InnerInherentDiv').children().get(0), { compose: { model: 'viewmodels/VisualAnalytics/QualitativeSetup', activationData: { InherentSetupQualObj: { data, ScenarioId } } } }, InherentVM);
            }
            $('#loadingMainImgDiv').hide();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyCategoryTabClick() method in InherentSetup.js';
            logger.logMessage(msg);
        }
    }

    function OpenConfigureResponseTypePopup(data, event) {
        try {
            if (InherentVM.SurveyGroupType() === 'QTDR') {
                InherentVM.QuantitativeSetup.OpenConfigureResponseTypePopup();
            }
            else if (InherentVM.SurveyGroupType() === 'QLDR') {
                InherentVM.QualitativeSetup.OpenQualRespSetupPopup();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenConfigureResponseTypePopup() method in InherentSetup.js';
            logger.logMessage(msg);
        }
    }

    function SurveyCategoryModel(item) {
        try {
            var self = this;
            self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
            self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
            self.SurveyCategoryShortName = ko.observable(item.SurveyCategoryShortName);
            self.SurveyType = ko.observable(item.SurveyType);
            self.Applicability = ko.observable(item.Applicability);
            self.SurveyGroupId = ko.observable(item.SurveyGroupId);
            self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
            self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
            self.IsEditable = ko.observable(item.IsEditable);
            self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
            self.AssessmentTypeName = ko.observable(item.AssessmentTypeName);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in InherentSetup.js';
            logger.logMessage(msg);
        }
    }
});

